module.exports = [
	{
		path: 'vantage_job_form/:id',
		name: 'Vantage Job Form',
		component: () => import('@/pages/maestro/forms/vantage_job_form.vue'),
		meta: {
			label: 'Vantage Job Form',
			icon: 'view_quilt',
			description: '',
			disabled: true
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_vantage.js